<header [ngClass]="{'openMenu': openMenu}">
  <div class="logo">
    <img routerLink="/" src="../assets/img/logo-mini.svg" alt="logo" class="logo-image">
    <ng-container *ngIf="!(authService.isAuthenticated$ | async)"><span>Своя связь</span></ng-container>
    <ng-container *ngIf="authService.isAuthenticated$ | async"><app-balance></app-balance></ng-container>
  </div>
  <nav>
    <ul class="nav-list">
      <li class="nav-list__item" routerLinkActive="active" routerLink="/feedback" (click)="navigateUrl('feedback')">
        <ui-icon nameIcon="help"></ui-icon>
        <span class="nav-list__item-title">Обращение в СвояСвязь</span>
      </li>
      <li class="nav-list__item" routerLinkActive="active" (click)="navigateUrl('vacantion')">
        <ui-icon nameIcon="engineering"></ui-icon>
        <span class="nav-list__item-title">Вакансии</span>
      </li>
      <li class="nav-list__item" routerLinkActive="active"  (click)="navigateUrl('police')">
        <ui-icon nameIcon="local_police"></ui-icon>
        <span class="nav-list__item-title">Законы</span>
      </li>
      <li class="nav-list__item" *ngIf="(authService.isAuthenticated$ | async)" (click)="navigate('/chat')" routerLinkActive="active" routerLink="/chat" >
        <ui-icon nameIcon="chat"></ui-icon>
        <span class="nav-list__item-title">Сообщения и звонки</span>
      </li>
      <li class="nav-list__item" (click)="navigate('/help')" routerLinkActive="active"  routerLink="/help">
        <ui-icon nameIcon="help"></ui-icon>
        <a class="nav-list__item-title">Инструкции</a>
      </li>
      <li class="nav-list__item nav-list__item--user hide-mobile"
          *ngIf="(authService.isAuthenticated$ | async) && (name$ | async)">
        <span class="nav-list__item-title">{{name$ | async}}</span>
        <ui-icon nameIcon="person"></ui-icon>
      </li>
      <li (click)="logout()" class="nav-list__item nav-list__item--exit" *ngIf="(authService.isAuthenticated$ | async)">
        <ui-icon nameIcon="logout"></ui-icon>
        <span class="nav-list__item-title">Выход</span>
      </li>
      <li (click)="navigateUrl('login')" *ngIf="!(authService.isAuthenticated$ | async)" class="nav-list__item nav-list__item--exit" >
        <ui-icon nameIcon="login"></ui-icon>
        <span class="nav-list__item-title">Вход</span>
      </li>
    </ul>
  </nav>
  <div class="action-mobile">
    <div class="user-info" *ngIf="(authService.isAuthenticated$ | async)">
      <span class="user-info__title">{{name$ | async}}</span>
      <ui-icon class="user-info__icon icon-action" routerLinkActive="active" routerLink="/user" nameIcon="person"></ui-icon>
    </div>
    <div class="action" (click)="setStateMenu()">
      <span class="action__title">Меню</span>
      <div class="header-switch menuSwitch" >
        <span></span>
      </div>
    </div>
  </div>

</header>

<div class="main">
  <router-outlet></router-outlet>
</div>

<app-gallery-image *ngIf="galleryService.stateVisible | async" [moderation]="true"></app-gallery-image>
